import { Card, CardContent } from '@/components/ui/card'
import Loader from '@/components/ui/Loader'
import { useReactTable, getCoreRowModel } from '@tanstack/react-table'
import MyDataTable from 'components/ui/my-data-table'
import React, { useMemo } from 'react'
import useSWR from 'swr'
import { columns } from './data-table-column'
import DataTableToolbar from './data-table-toolbar'

const LayerGroups = () => {
  const {
    data = [],
    isLoading,
    isValidating,
    mutate,
  } = useSWR(['/layer-groups'])

  const visibleData = useMemo(
    () => data.filter((item) => item.state !== -1),
    [data],
  )

  const table = useReactTable({
    data: visibleData,
    columns,
    enableRowSelection: false,
    getRowId: (row) => row.id,
    getCoreRowModel: getCoreRowModel(),
  })
  if (isLoading || isValidating) return <Loader>Load layer groups</Loader>

  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="mb-2 flex-shrink-0">
        <DataTableToolbar mutate={mutate} />
      </div>
      <div className="min-h-0 flex-1">
        <Card className="flex h-full flex-col">
          <CardContent className="flex-1 overflow-hidden pb-0 pl-4 pr-0">
            <div className="h-full overflow-auto">
              <MyDataTable table={table} />
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default LayerGroups
